module.exports = __webpack_public_path__ + "img/Watney7.07a25fd1.jpg";